import { render, staticRenderFns } from "./DialogCancelamentoCompras.vue?vue&type=template&id=4beb9fea"
import script from "./DialogCancelamentoCompras.vue?vue&type=script&lang=js"
export * from "./DialogCancelamentoCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports